<template>
  <v-dialog
    persistent
    max-width="500px"
    :value="show">
    <v-card class="px-4 pt-4 pb-4">
      <v-card-title>
        <h2>
          {{ title }}
        </h2>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap py-2 px-4>
          <v-flex xs12>
            <v-form row wrap ref="form" @submit.prevent="save()">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.name"
                    v-validate="'required|max:100'"
                    data-vv-name="name"
                    data-vv-as="nombre"
                    :error-messages="errors.collect('name')"
                    label="Nombre"
                    color="black">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md12>
                  <v-select
                    v-model="form.type"
                    :items="types"
                    v-validate="'required|max:45'"
                    data-vv-name="type"
                    data-vv-as="tipo"
                    :error-messages="errors.collect('type')"
                    label="Tipo"
                    color="black"
                    :disabled="edit && !canChangeType">
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="form.type === 'unsolved'">
                <v-flex md12>
                  <v-text-field
                    v-model="form.days"
                    v-validate="'required|max:100'"
                    data-vv-name="days"
                    min="0"
                    data-vv-as="Días para cerrar"
                    :error-messages="errors.collect('days')"
                    label="Días para cerrar chat"
                    type="number"
                    color="black"/>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-btn flat color="black" @click="$emit('close')">
            CANCELAR
          </v-btn>
          <v-btn flat class="k-orange-linear-text" @click="save">
            GUARDAR
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  inject: ['$validator'],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: false,
    },
    canChangeType: {
      type: Boolean,
      default: false,
    },
    types: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    title() {
      return this.edit ? 'Editar categoría de chat' : 'Crear categoría de chat';
    },
    route() {
      let route = 'chat_categories';
      if (this.edit) {
        route += `/${this.id}`;
      }
      return route;
    },
  },
  methods: {
    save() {
      let request;
      if (this.edit) {
        request = this.axios.patch(this.route, this.form).then(() => {
          this.$emit('update');
        });
      } else {
        request = this.axios.post(this.route, this.form).then(() => {
          this.$emit('update');
        });
      }
      request.catch((error) => {
        this.$emit('error', error.response.data);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/ChatCategoryDialog.vue